/* eslint-disable local/no-conditional-class-names */
import { useCardStyles } from '@chakra-ui/react';
import cx from 'classnames';
import React, { forwardRef } from 'react';

import { Heading, HeadingProps } from '../Heading/Heading';

export type CardSectionTitleProps = Omit<
  HeadingProps<'h3'>,
  'as' | 'size' | 'variant' | '__orbitStyleConfig'
>;

export const CardSectionTitle = forwardRef<
  HTMLHeadingElement,
  CardSectionTitleProps
>(({ className, ...props }, ref) => {
  const styles = useCardStyles();

  return (
    <Heading
      {...props}
      ref={ref}
      as="h3"
      className={cx('orbit-card__section-title', className)}
      __orbitStyleConfig={styles.sectionTitle}
    />
  );
});
